var _style, _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:none;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1_00000047056286400740158280000001894717445875503803_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2806253936144"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.4,
    y: 75.4,
    className: "st1",
    width: 731.5,
    height: 731.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.8469,
    y1: -1413.3978,
    x2: 603.2581,
    y2: -1127.2311,
    gradientTransform: "matrix(1 0 0 1 0 1731.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7EB5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A38F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.1,806.9c-30.4-24-45.6-48.9-45.6-74.6c-0.6-23.7,8.2-46.5,24.3-63.8l346.2-346.2 c23.7,20.2,38,43.3,42.4,69.3c4.7,25.5-3.5,51.8-22.2,69.9L402.8,806.9H403.1z M279.6,683.4c-30.7-24-45.6-48.9-45.6-74.6 c-0.6-23.7,7.9-46.5,24.3-63.8l346.2-346.2c23.7,20.2,38,43.3,42.4,69.3c4.7,25.5-3.5,51.8-22.2,69.9L279.3,683.4H279.6z  M156.1,559.9c-30.7-24-45.6-48.9-45.6-74.6c-0.6-23.7,8.2-46.5,24.3-63.8L480.9,75.4c23.7,20.5,38,43.3,42.4,69.3 c4.7,25.5-3.5,51.8-22.2,69.9L155.8,559.9H156.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinaIcon);
export default __webpack_public_path__ + "static/media/lina_icon.dae0943a7c6a00979681efc77637089f.svg";
export { ForwardRef as ReactComponent };